import React, {useCallback} from "react";
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    Toolbar,
    useCreate,
    useRedirect,
    useNotify,
    SaveButton
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import "../legal_entity/styles/main.css"
import required from "../helper/Required";
import TextEditor from "../component/TextEditor";

const InstructionCreate = props => {
    const useStyles = makeStyles({
        inlineBlock: {
            display: 'inline-flex',
        },
    });
    const classes = useStyles();

    const Title = props => (
        <div className="title-wrapper">
            <span className="title-text">Додавання інструкції</span>
        </div>
    );

    const InstructionCreateToolbar = props => {
        const [create, { loading, error }] = useCreate('instructions');
        const redirectTo = useRedirect();
        const notify = useNotify();
        const { basePath } = props;
        const handleSave = useCallback(
            (values, redirect) => {
                console.log(values);
                create(
                    { payload: {data: {...values}} },
                    {
                        onSuccess: ({data: newRecord}) => {
                            notify('Інструкція додана', 'info');
                            redirectTo(redirect, basePath, newRecord.id, newRecord);
                        },
                        onError: (error) => {
                            console.log(error);
                        }
                    }
                );
            },
            [create, notify, redirectTo, basePath]
        );

        if (error) {
            notify('Помилка збереження інструкції', 'warning');
        }

        return <Toolbar {...props}><SaveButton {...props} disabled={loading} submitOnEnter={false} onSave={handleSave} /></Toolbar>;
    };

    return (
        <Create {...props} title={<Title {...props} />}>
            <SimpleForm toolbar={<InstructionCreateToolbar {...props} />}>
                <TextInput formClassName="tab-content-item" label="Заголовок" source="title" validate={required.validateRequired} />
                <TextInput formClassName="tab-content-item" label="Аліас" source="alias" validate={required.validateRequired} />
                <BooleanInput source={"active"} label={'Активна'} />
                <TextEditor {...props} formClassName={classes.inlineBlock} source="content" />
            </SimpleForm>
        </Create>
    );
};

export default InstructionCreate;
